import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import InputFieldWrapper from "src/components/registrantProfile/InputFieldWrapper";
import { regProfileStyles } from "./registrantProfileStyles";
import useFormikField from "../../hooks/useFormikField";
import { InputSectionTag } from "../../types/registrantProfileTypes";
import { getValue, trimSpaces } from "src/utils/helperFunctions";

const fieldsBeforePhoneNumber = [
    { label: "Name", name: "name" },
    { label: "Company", name: "company" },
    { label: "Street", name: "street" },
    { label: "City", name: "city" },
    { label: "State", name: "state" },
    { label: "Country", name: "country" },
    { label: "Zip", name: "zip" },
];

const InputSection = ({
    tag,
    disabled = false,
    formik,
}: {
    tag: InputSectionTag;
    disabled?: boolean;
    formik: any;
}) => {
    const { getFieldName, getFieldValue, fieldHasErrors, getValidationError } =
        useFormikField(formik, tag);

    const renderField = ({
        fieldName,
        label,
        type = "text",
        fieldDisabled = disabled,
        onChange,
    }: {
        fieldName: string;
        label: string;
        type?: string;
        fieldDisabled?: boolean;
        onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
    }) => {
        return (
            <InputFieldWrapper
                label={label}
                hasWarning={fieldHasErrors(fieldName)}
                warning={getValidationError(fieldName)}
            >
                <TextField
                    name={getFieldName(fieldName)}
                    type={type}
                    value={getFieldValue(fieldName)}
                    onChange={onChange}
                    sx={regProfileStyles.textField}
                    inputProps={{
                        style: {
                            margin: 0,
                            padding: "10px 8px",
                        },
                    }}
                    disabled={fieldDisabled}
                />
            </InputFieldWrapper>
        );
    };

    return (
        <Grid
            container
            rowSpacing={2}
            columnSpacing={4}
            paddingTop={2}
            paddingBottom={2}
        >
            {fieldsBeforePhoneNumber.map((data, index) => (
                <Grid key={index} md={4} sm={6} xs={12}>
                    {renderField({
                        fieldName: data.name,
                        label: data.label,
                        onChange: (e) => {
                            const value = getValue(e.target.value);
                            formik.setFieldValue(
                                getFieldName(data.name),
                                value,
                            );
                        },
                    })}
                </Grid>
            ))}
            <Grid md={4} sm={6} xs={12}>
                <InputFieldWrapper
                    label="Phone"
                    hasWarning={fieldHasErrors("phone")}
                    warning={getValidationError("phone")}
                >
                    <PhoneInput
                        id={getFieldName("phone")}
                        name={getFieldName("phone")}
                        className="phoneInput"
                        value={getFieldValue("phone")}
                        disabled={disabled}
                        onChange={(phoneNumber) => {
                            formik.setFieldValue(
                                getFieldName("phone"),
                                phoneNumber ?? "",
                            );
                        }}
                        numberInputProps={{
                            style: {
                                padding: "12px",
                                borderRadius: "15px",
                                borderColor: "#3A354180",
                                borderWidth: "1px",
                                backgroundColor: "transparent",
                                fontFamily: "'Inter', sans-serif",
                                fontSize: "15px",
                            },
                        }}
                    />
                </InputFieldWrapper>
            </Grid>
            <Grid md={4} sm={6} xs={12}>
                {renderField({
                    fieldName: "email",
                    label: "Email",
                    onChange: (e) => {
                        const value = trimSpaces(getValue(e.target.value));
                        formik.setFieldValue(getFieldName("email"), value);
                    },
                    fieldDisabled:
                        disabled || tag === InputSectionTag.OWNER_INFO,
                })}
            </Grid>
        </Grid>
    );
};

export default InputSection;
